import React from 'react'
import AuditCreate from './operation/AuditCreate'
import AuditUpdate from './operation/AuditUpdate'
import AuditRemove from './operation/AuditRemove'

const Content = ({ data }) => {
  if (data.operation === 'create') return <AuditCreate data={data} />
  if (data.operation === 'update') return <AuditUpdate data={data} />
  if (data.operation === 'remove') return <AuditRemove data={data} />
}

export default Content
